import { render, staticRenderFns } from "./BatchBusiness.vue?vue&type=template&id=e84dd70a&scoped=true&"
import script from "./BatchBusiness.vue?vue&type=script&lang=js&"
export * from "./BatchBusiness.vue?vue&type=script&lang=js&"
import style0 from "./BatchBusiness.vue?vue&type=style&index=0&id=e84dd70a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84dd70a",
  null
  
)

export default component.exports